import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import PrimaryOutlineButton from '../../../Buttons/PrimaryOutlineButton'
import PopHover from '../../../PopHover'
import ActionButtons from '../../../ActionButton'
import AutoCompleteSearch from '../../../ListWithSearch/selectListWithSearch/AutoCompleteSearch'

export default function DropDownSelectListWithSearch({
  dataList,
  onDataChanged,
  defaultLabel,
  filtersValues,
  id,
}) {
  const [index, setIndex] = useState(25)
  const [selected, setSelected] = useState([])
  const [checkedAll, setCheckedAll] = useState(true)
  const [search, setSearch] = useState('')
  const [label, setLabel] = useState('Tous')
  const [init, setInit] = useState(false)
  const [data, setData] = useState(dataList.slice(0, 25))
  const [isMoreLoading, setIsMoreLoading] = useState(false)
  const [anchorEl, setAnchorEl] = React.useState(null)

  //Init selected List
  useEffect(() => {
    if (dataList) {
      const checkedAll = filtersValues?.includes('TOUS')
      if (filtersValues && filtersValues.length > 0 && !checkedAll) {
        const initFilterTAB = filtersValues ? filtersValues : []
        setSelected(initFilterTAB)
      } else if (selected.length === 0) {
        const selecteds = dataList.map((n) => n.code)
        setSelected(selecteds)
      }
      setData(dataList.slice(0, 25))
      setInit(true)
    }
  }, [dataList, filtersValues])
  //Change lable
  useEffect(() => {
    handleLabelDisplay()
  }, [selected])
  const handleLabelDisplay = () => {
    let text = ''
    text = dataList
      .filter((el) => selected.includes(el.code))
      .map((el) => el.name)
      .join(', ')

    if (text.length > 20) {
      text = text.substring(0, 20).concat('...')
    }
    setLabel(
      selected.length > 0 && selected.length < dataList.length ? `${text}` : 'Tous'
    )
  }

  //FETCH more data with search
  useEffect(() => {
    const delayDebounceFn = setTimeout(() => {
      if (search.length > 0) {
        onSearch(search)
      } else {
        if (init) {
          setData(dataList.slice(0, 25))
          setIndex(25)
        }
      }
    }, 500)

    return () => clearTimeout(delayDebounceFn)
  }, [search])

  const onChangeSearch = (value) => {
    let val = value.trim()
    setSearch(val)
    setIndex(25)
  }

  const onSearch = (search) => {
    const filteredSuggestions = dataList
      .filter((suggestion) =>
        suggestion.name.toLowerCase().includes(search.toLowerCase())
      )
      .filter((item) => item)
    setData(filteredSuggestions)
  }

  //FETCH more data with scroll
  const fetchMoreData = (event) => {
    if (
      Math.round(event.target.scrollHeight - event.target.scrollTop) <=
        event.target.clientHeight &&
      index < dataList.length &&
      !isMoreLoading
    ) {
      setIsMoreLoading(true)
      setTimeout(() => {
        setIndex(index + 25)
        setData(dataList.slice(0, index + 25))
        setIsMoreLoading(false)
      }, 500)
    }
  }
  // Click single data
  const handleToggle = (value) => () => {
    const selectedIndex = selected.indexOf(value)
    let newSelected = []

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, value)
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1))
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1))
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1)
      )
    }
    setSelected(newSelected)
  }

  const handleDoubleClick = (value) => () => {
    setSelected([value])
  }
  // Click All list DATA
  const handleToggleAll = (event) => {
    setCheckedAll(event.target.checked)
    if (event.target.checked) {
      const newSelecteds = dataList.map((n) => n.code)
      setSelected(newSelecteds)
      return
    }
    setSelected([])
  }
  const handleDoubleClickAll = () => {
    setCheckedAll(!checkedAll)
    if (!checkedAll) {
      const newSelecteds = dataList.map((n) => n.code)
      setSelected(newSelecteds)
      return
    }
    setSelected([])
  }

  //Verif checked element
  const isSelected = (code) => selected.indexOf(code) !== -1

  // Enregistrer Filter
  const onApply = (event) => {
    if (selected.length === 0) {
      setSelected(dataList.map((n) => n.code))
      onDataChanged(null)
    } else {
      onDataChanged(
        selected.length === dataList.length ? ['TOUS'] : [...new Set(selected)]
      )
    }
    toggleDrawer(false, event)
    setAnchorEl(false)
  }
  // Annuler Filter
  const onCancel = (event) => {
    toggleDrawer(false, event)
    setSelected(dataList.map((n) => n.code))
    onDataChanged(null)
    setAnchorEl(false)
  }

  // open && close drawer
  const toggleDrawer = (open, event) => {
    if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
      return
    }
    setSearch('')
    setData(dataList.slice(0, 25))
  }
  const open = Boolean(anchorEl)

  return (
    <>
      <PrimaryOutlineButton
        id={'filter-prestation-popover'}
        onClick={(event) => setAnchorEl(event.currentTarget)}
        content={
          <span id={`filter-prestation-result-${label}`}>
            {defaultLabel}: {label}{' '}
          </span>
        }
      />
      <PopHover
        open={open}
        anchorEl={anchorEl}
        onClose={onCancel}
        content={
          <div style={{ width: '240px' }}>
            <AutoCompleteSearch
              handleToggle={handleToggle}
              handleDoubleClick={handleDoubleClick}
              dataList={data}
              fetchMoreData={fetchMoreData}
              onChangeSearch={onChangeSearch}
              search={search}
              handleDoubleClickAll={handleDoubleClickAll}
              handleToggleAll={handleToggleAll}
              numSelected={selected.length === dataList.length}
              isSelected={isSelected}
              isProgrammer={true}
            />
            <ActionButtons
              isProgrammer={true}
              onApply={onApply}
              onCancel={onCancel}
            />
          </div>
        }
        id={id}
        className="pophover-container"
      />
    </>
  )
}
DropDownSelectListWithSearch.propTypes = {
  dataList: PropTypes.array,
  onDataChanged: PropTypes.func,
  defaultLabel: PropTypes.string,
  filtersValues: PropTypes.array,
  id: PropTypes.bool,
}
